<template>
  <div class="radio-span" :class="[is_full, is_survey]">
    <span><radio :correct="correct" :caption="caption" :group="group" :title="title" :groupQuestion="groupQuestion"></radio></span>
    <p v-if="is_strong">
      <strong>
        {{title}}
      </strong>
    </p>
    <p v-else>
      {{title}}
    </p>
  </div>
</template>

<script>
  import radio from '../atoms/radio'
  export default {
    props: ['title', 'strong', 'correct', 'caption', 'full', 'survey', 'group', 'groupQuestion'],
    components: {
      'radio': radio
    },
    computed: {
      is_strong () {  return this.strong },
      is_full () {
        if (!this.full) {
          return 'span-8-lg span-8-md span-16-sm span-16-xs'
        } else {
          return 'span-16-lg span-16-md span-16-sm span-16-xs'
        }
      },
      is_survey () {
        if (!this.survey) {
          return ''
        } else {
          return 'span-8-md span-16-sm span-16-xs'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .radio-span {
    cursor: default;
    display: flex;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// radio_span.vue?9495713c